// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@imgs/register/new-theme/head-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@imgs/register/red-theme/logo-big.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@imgs/register/new-theme/bottom-body-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@imgs/activity/check.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes skin7_rotate__eJRAR {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.skin7_skin5__wQ8jZ {
  height: 100%;
  background-color: #f5f6f9;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am {
  padding: 5.333333vw 4.266667vw 2.666667vw;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 53.333333vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_logoBox__bLuyg {
  font-size: 5.333333vw;
  line-height: 5.333333vw;
  display: flex;
  align-items: center;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_logoBox__bLuyg .skin7_logo__NcaXX {
  margin-right: 2.666667vw;
  width: 11.2vw;
  height: 11.2vw;
  background-size: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_logoBox__bLuyg .skin7_logoBoxRight__\\+XO6p {
  display: flex;
  flex-direction: column;
  font-size: 5.066667vw;
  color: #fff;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw {
  margin-top: 4vw;
  width: 91.466667vw;
  background: linear-gradient(180deg, #FBE5D7 0%, #FFFFFF 27.54%);
  border-radius: 2.133333vw;
  padding-bottom: 6.666667vw;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperHead__4siQy {
  width: 100%;
  height: 13.333333vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 7.733333vw;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperHead__4siQy.skin7_centerLayout__WDexa {
  justify-content: center;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperHead__4siQy.skin7_centerLayout__WDexa .skin7_inputWrapperHeadItemImg__i7cxf {
  width: 3.733333vw !important;
  height: 3.733333vw !important;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperHead__4siQy.skin7_centerLayout__WDexa .skin7_inputWrapperHeadItemText__\\+Ah-W {
  margin-top: 0.533333vw;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperHead__4siQy .skin7_inputWrapperHeadItem__IquW8 {
  display: flex;
  align-items: center;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperHead__4siQy .skin7_inputWrapperHeadItem__IquW8 .skin7_inputWrapperHeadItemImg__i7cxf {
  width: 3.2vw;
  height: 3.733333vw;
  margin-right: 1.6vw;
  display: block;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperHead__4siQy .skin7_inputWrapperHeadItem__IquW8 .skin7_inputWrapperHeadItemText__\\+Ah-W {
  font-size: 3.2vw;
  line-height: 3.2vw;
  color: #DE9960;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe {
  margin-top: 3.2vw;
  padding: 0 3.2vw;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe .skin7_inputWrapperContainetTips__8jjsl {
  font-size: 3.733333vw;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe .skin7_inputBox__pQ4ea {
  position: relative;
  display: flex;
  align-items: center;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe .skin7_inputBox__pQ4ea .skin7_inputBoxSymbol__cyJYQ {
  font-size: 10.133333vw;
  line-height: 13.866667vw;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe .skin7_inputBox__pQ4ea .adm-input-element {
  font-size: 8vw;
  line-height: 8vw;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe .skin7_inputBox__pQ4ea .adm-input-element::placeholder {
  font-size: 5.866667vw;
  line-height: 8vw;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe .skin7_inputBox__pQ4ea .skin7_text__B0\\+3s {
  position: absolute;
  right: 0;
  bottom: 3.733333vw;
  display: flex;
  align-items: center;
  color: #AD6800;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe .skin7_inputBox__pQ4ea .skin7_text__B0\\+3s .skin7_clear__YtGpD {
  padding-left: 2.4vw;
  color: #8C8C8C;
  font-size: 4.266667vw;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe .skin7_moneyOptions__FRkHP {
  margin-top: 1.333333vw;
  display: flex;
  align-items: center;
}
.skin7_skin5__wQ8jZ .skin7_header__BM6am .skin7_inputWrapper__UmLmw .skin7_inputWrapperContainer__TPzLe .skin7_moneyOptions__FRkHP .skin7_moneyItem__Lnvkr {
  width: 22.933333vw;
  height: 8vw;
  padding: 1.066667vw 2.133333vw;
  border-radius: 1.6vw;
  border: 1px solid #ff2f2f;
  margin-right: 2.933333vw;
  color: #ff2f2f;
  box-sizing: border-box;
  text-align: center;
  font-size: 4vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M {
  width: 93.866667vw;
  margin: 2.933333vw auto;
  background: #fff;
  border-radius: 2.133333vw;
  padding-bottom: 5.333333vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_title__A0yao {
  width: 100%;
  height: 10.133333vw;
  background: linear-gradient(180deg, #FDF2E5 0%, #FBE4CE 100%);
  border-radius: 1.6vw 1.6vw 0px 0px;
  text-align: center;
  line-height: 10.133333vw;
  font-weight: 400;
  font-size: 3.2vw;
  color: #DE9960;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M h3 {
  font-weight: 600;
  font-size: 4.266667vw;
  color: #333;
  padding: 4.266667vw 4.266667vw 1.6vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M h3 span {
  font-size: 3.2vw;
  color: #BB6C1D;
  font-weight: normal;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_loanTermList__WVgKL {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 4.266667vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_loanTermList__WVgKL .skin7_loanTermItem__9OeE2 {
  margin-top: 2.133333vw;
  width: 41.066667vw;
  height: 16vw;
  padding-bottom: 1.6vw;
  background-color: #f3f4f6;
  text-align: center;
  border-radius: 1.066667vw;
  font-size: 4vw;
  box-sizing: border-box;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_loanTermList__WVgKL .skin7_loanTermItem__9OeE2 p {
  margin-top: 1.6vw;
  color: #8C8C8C;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_loanTermList__WVgKL .skin7_loanTermItem__9OeE2 p.skin7_samllText__oEW1\\+ {
  font-size: 3.2vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_loanTermList__WVgKL .skin7_loanTermItem__9OeE2.skin7_active__PKBkj {
  background-color: #fff9f4;
  border: 1Px solid #bb9674;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_loanTermList__WVgKL .skin7_loanTermItem__9OeE2.skin7_active__PKBkj p {
  color: #bb9674;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_loanTermList__WVgKL .skin7_loanTermItem__9OeE2.skin7_is360Channel__vTrNI {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.266667vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS {
  margin-top: 5.333333vw;
  box-sizing: border-box;
  padding: 0 4.266667vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS p {
  width: 100%;
  display: flex;
  justify-content: center;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS p span {
  display: inline-block;
  color: #c16818;
  height: 10.933333vw;
  line-height: 10.933333vw;
  padding: 0 4.266667vw;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_phoneBox__uxHPK {
  height: 13.333333vw;
  background: #f4f5f7;
  border-radius: 2.133333vw;
  display: flex;
  align-items: center;
  margin: 2.4vw auto 0;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_phoneBox__uxHPK .skin7_label__pGNH6 {
  width: 45.333333vw;
  text-align: center;
  font-size: 4.266667vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_phoneBox__uxHPK .adm-input-element {
  font-size: 4.266667vw;
  line-height: 8vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_phoneBox__uxHPK .adm-input-element::placeholder {
  font-size: 4.266667vw;
  line-height: 8vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_getCms__7A595 {
  margin-top: 3.2vw;
  height: 13.333333vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(180deg, #ffcfa0 1%, #e19459);
  border-radius: 1.6vw;
  color: #FFFFFF;
  font-size: 4.266667vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_agreement__mWN77 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_agreement__mWN77 .skin7_primary__Xej6e {
  color: #DE9960;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_agreement__mWN77 {
  margin-top: 3.2vw;
  font-size: 3.2vw;
  color: #8C8C8C;
  line-height: 4.8vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_agreement__mWN77.skin7_animation__202Uy {
  position: relative;
  animation: skin7_shake__IZRek 0.1s;
}
@keyframes skin7_shake__IZRek {
  0% {
    left: 2.133333vw;
  }
  50% {
    left: -2.133333vw;
  }
  100% {
    left: 0;
  }
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_agreement__mWN77 .skin7_checked__TE4gh {
  margin-right: 1.6vw;
  border: 1px solid #D9D9D9;
  border-radius: 100%;
  width: 4.8vw;
  height: 4.8vw;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_agreement__mWN77 .skin7_checked__TE4gh.skin7_active__PKBkj {
  position: relative;
  border: none;
  background: #DE9960;
}
.skin7_skin5__wQ8jZ .skin7_checkBox__fn8-M .skin7_bottomBody__FEibS .skin7_agreement__mWN77 .skin7_checked__TE4gh.skin7_active__PKBkj::before {
  position: absolute;
  top: 1.6vw;
  left: 1.066667vw;
  width: 2.666667vw;
  height: 1.866667vw;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100%;
}
.skin7_skin5__wQ8jZ .skin7_tipBox__Pz5yg {
  padding-bottom: 13.333333vw;
}
.skin7_skin5__wQ8jZ .skin7_tipBox__Pz5yg .skin7_tip__2tMiY {
  font-size: 3.2vw;
  line-height: 5.333333vw;
  text-align: center;
  color: #8C8C8C;
}
.skin7_skin5__wQ8jZ .skin7_dialogOverlay__EAcoE {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: none;
}
.skin7_skin5__wQ8jZ .skin7_dialogOverlay__EAcoE.skin7_showPopup__5UUvZ {
  display: block;
}
.skin7_skin5__wQ8jZ .skin7_dialogOverlay__EAcoE .skin7_dialogMain__mPBLq {
  width: 85.333333vw;
  height: 48vw;
  border-radius: 2.133333vw;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 5.333333vw 0;
  box-sizing: border-box;
}
.skin7_skin5__wQ8jZ .skin7_dialogOverlay__EAcoE .skin7_dialogMain__mPBLq .skin7_close__r2dDW {
  width: 100%;
  font-size: 5.333333vw;
  text-align: right;
  margin-right: 5.333333vw;
  color: rgb(214, 217, 223);
  padding-right: 5.333333vw;
  box-sizing: border-box;
}
.skin7_skin5__wQ8jZ .skin7_dialogOverlay__EAcoE .skin7_dialogMain__mPBLq .skin7_inputBox__pQ4ea {
  width: 76vw;
  height: 12.8vw;
  border: 1px solid #e19459;
  margin: 2.666667vw auto;
  padding-left: 5.333333vw;
  border-radius: 2.133333vw;
  display: flex;
  align-items: center;
}
.skin7_skin5__wQ8jZ .skin7_dialogOverlay__EAcoE .skin7_dialogMain__mPBLq .skin7_inputBox__pQ4ea .skin7_code__6Lh5J {
  width: 40vw;
  text-align: center;
  color: #e19459;
}
.skin7_skin5__wQ8jZ .skin7_dialogOverlay__EAcoE .skin7_dialogMain__mPBLq .skin7_inputBox__pQ4ea .adm-input-element {
  font-size: 4vw;
  line-height: 8vw;
}
.skin7_skin5__wQ8jZ .skin7_dialogOverlay__EAcoE .skin7_dialogMain__mPBLq .skin7_limit__JqhXn {
  margin: 4.8vw auto;
  width: 75.466667vw;
  height: 11.733333vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(180deg, #ffcfa0 1%, #e19459);
  border-radius: 1.6vw;
  color: #FFFFFF;
  font-size: 4.266667vw;
}

.adm-auto-center .adm-auto-center-content {
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/mixin.scss","webpack://./src/pages/register/components/skin7/skin7.module.scss","webpack://./src/styles/var.scss"],"names":[],"mappings":"AA4KA;EACE;IACE,uBAAA;EC3KF;ED8KA;IACE,yBAAA;EC5KF;AACF;AAJA;EACE,YAAA;EACA,yBAAA;AAMF;AAJE;EACE,yCAAA;EACA,WAAA;EACA,4BAAA;EACA,iCAAA;EACA,yDAAA;AAMJ;AAJI;EACE,qBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AAMN;AAFM;EACE,wBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,yDAAA;AAIR;AADM;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;AAGR;AACI;EACE,eAAA;EACA,kBAAA;EACA,+DAAA;EACA,yBAAA;EACA,0BAAA;AACN;AACM;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AACR;AAAQ;EACE,uBAAA;AAEV;AADU;EACE,4BAAA;EACA,6BAAA;AAGZ;AADU;EACE,sBAAA;AAGZ;AAAQ;EACE,aAAA;EACA,mBAAA;AAEV;AADU;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAGZ;AADU;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AAGZ;AAEM;EACE,iBAAA;EACA,gBAAA;AAAR;AACQ;EACE,qBAAA;AACV;AACQ;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AACV;AAEU;EACE,sBAAA;EACA,wBAAA;AAAZ;AAIY;EACE,cAAA;EAEA,gBAAA;AAHd;AAIc;EACE,qBAAA;EACA,gBAAA;AAFhB;AAOU;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AALZ;AAOY;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AALd;AASQ;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;AAPV;AAQU;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,oBAAA;EACA,yBAAA;EACA,wBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AANZ;AAaE;EACE,kBAAA;EAEA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;AAZJ;AAaI;EACE,WAAA;EACA,mBAAA;EACA,6DAAA;EACA,kCAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAXN;AAaI;EACE,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,oCAAA;AAXN;AAYM;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AAVR;AAaI;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,qBAAA;AAXN;AAYM;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;AAVR;AAWQ;EACE,iBAAA;EACA,cAAA;AATV;AAUU;EACE,gBAAA;AARZ;AAWQ;EACE,yBAAA;EACA,yBAAA;AATV;AAUU;EACE,cAAA;AARZ;AAWQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AATV;AAcI;EACE,sBAAA;EACA,sBAAA;EACA,qBAAA;AAZN;AAaM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAXR;AAYQ;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,4BAAA;EACA,0BAAA;EACA,yDAAA;AAVV;AAaM;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AAXR;AAYQ;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AAVV;AAaU;EACE,qBAAA;EAEA,gBAAA;AAZZ;AAaY;EACE,qBAAA;EACA,gBAAA;AAXd;AAgBM;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8DAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AAdR;AAgBM;EDbJ,aAAA;EAGE,uBAAA;EAIA,mBAAA;ECQI,eAAA;AAZR;AAcQ;EACE,cAAA;AAZV;AAOM;EAQE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAZR;AAcQ;EACE,kBAAA;EACA,kCAAA;AAZV;AAeQ;EACE;IACE,gBAAA;EAbV;EAgBQ;IACE,iBAAA;EAdV;EAiBQ;IACE,OAAA;EAfV;AACF;AAkBQ;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAhBV;AAmBU;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;AAjBZ;AAmBY;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,qBAAA;AAjBd;AAyBE;EACE,2BAAA;AAvBJ;AAwBI;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cCrTY;AD+RlB;AA0BE;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AAxBJ;AAyBI;EACE,cAAA;AAvBN;AAyBI;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,qBAAA;EACA,sBAAA;AAvBN;AAwBM;EACE,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAtBR;AAwBM;EACE,WAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAtBR;AAuBQ;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AArBV;AAwBU;EACE,cAAA;EAEA,gBAAA;AAvBZ;AA2BM;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8DAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AAzBR;;AAiCI;EACE,6BAAA;AA9BN","sourcesContent":["@charset \"UTF-8\";\n\n// 圆圈\n@mixin circle($width) {\n  display: inline-block;\n  border-radius: 50%;\n  width: $width;\n  height: $width;\n}\n\n// 省略号样式\n@mixin ellipsis($lineNum: \"\") {\n  overflow: hidden;\n\n  @if $lineNum != \"\" {\n    /* stylelint-disable-next-line */\n    display: -webkit-box;\n    /* stylelint-disable-next-line */\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: $lineNum;\n  } @else {\n    display: inline-block;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n// css箭头\n@mixin arrow($direction, $width, $height, $color) {\n  display: inline-block;\n  width: 0;\n  height: 0;\n\n  @if $direction == \"top\" {\n    border-top: 0;\n    border-right: solid $width transparent;\n    border-bottom: solid $height $color;\n    border-left: solid $width transparent;\n  } @else if $direction == \"bottom\" {\n    border-top: solid $height $color;\n    border-right: solid $width transparent;\n    border-bottom: 0;\n    border-left: solid $width transparent;\n  } @else if $direction == \"left\" {\n    border-top: solid $height transparent;\n    border-right: solid $width $color;\n    border-bottom: solid $height transparent;\n    border-left: 0;\n  } @else if $direction == \"right\" {\n    border-top: solid $height transparent;\n    border-right: 0;\n    border-bottom: solid $height transparent;\n    border-left: solid $width $color;\n  }\n}\n\n// 上下左右居中，为解决被外部数据覆盖的问题，强制使用!important\n@mixin setXYMiddle($width, $height) {\n  position: absolute !important;\n  top: 50% !important;\n  left: 50% !important;\n  margin-top: -$height / 2 !important;\n  margin-left: -$width / 2 !important;\n  width: $width !important;\n  min-width: unset;\n  height: $height !important;\n}\n\n// 上下居中\n@mixin setYMiddle($height) {\n  position: absolute;\n  top: 50%;\n  margin-top: -$height / 2;\n  height: $height;\n}\n\n// 左右居中\n@mixin setXMiddle($width) {\n  position: absolute;\n  left: 50%;\n  margin-left: -$width / 2;\n  width: $width;\n}\n\n// 切换动画\n@mixin transition($type) {\n  transition: .3s $type;\n}\n\n// 按钮公共样式\n@mixin btn-normal($color) {\n  @include transition(background-color);\n\n  border-color: $color;\n  border-radius: 20px;\n  width: 90px;\n  height: 40px;\n  font-size: $font-size-14;\n  text-align: center;\n  color: $color-FFFFFF;\n  background: $color;\n  line-height: 40px;\n  cursor: pointer;\n  user-select: none;\n}\n\n// 失效状态，强制使用同一种颜色\n@mixin disable($type, $color) {\n  cursor: not-allowed !important;\n\n  @if $type == \"color\" {\n    color: $color !important;\n\n    &:hover {\n      color: $color !important;\n    }\n\n    &:active {\n      color: $color !important;\n    }\n  } @else if $type == \"background-color\" {\n    background-color: $color !important;\n\n    &:hover {\n      background-color: $color !important;\n    }\n\n    &:active {\n      background-color: $color !important;\n    }\n  }\n}\n\n// 全局阴影效果\n@mixin shadow {\n  box-shadow: 0 0 10px 2px rgba(#5E5C5C, .25);\n}\n\n// 变色样式\n@mixin action-green($type) {\n  @include transition($type);\n\n  cursor: pointer;\n\n  @if $type == \"color\" {\n    &:hover {\n      color: $color-55DE99 !important;\n    }\n\n    &:active {\n      color: $color-22B76B !important;\n    }\n  } @else if $type == \"background-color\" {\n    &:hover {\n      background-color: $color-55DE99 !important;\n    }\n\n    &:active {\n      background-color: $color-22B76B !important;\n    }\n  }\n}\n\n// 清除浮动\n@mixin clearfix {\n  &::after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// 旋转\n@mixin animation-rotate() {\n  animation-duration: 1s;\n  animation-name: rotate;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(1, 1, 1, 1);\n}\n\n// 文本n行溢出隐藏显示...\n@mixin ellipsis-basic($n) {\n  /* stylelint-disable-next-line value-no-vendor-prefix */\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: $n;\n  -webkit-line: $n;\n  word-break: break-all;\n  word-wrap: break-word;\n}\n\n// 文本不换行\n@mixin no-wrap {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// 宽高\n@mixin wh($w: 100%, $h: 100%) {\n  width: $w;\n  height: $h;\n}\n\n// 跳转文字 有hover效果\n@mixin link($color: $text-grey-color, $hover-color: $text-grey-color) {\n  position: relative;\n  color: $color;\n  cursor: pointer;\n  user-select: none;\n\n  @content;\n\n  &:hover {\n    color: $hover-color;\n  }\n}\n\n// 跳转文字 带下划线 有hover效果\n@mixin link-underline($color: $text-grey-color, $hover-color: $text-grey-color) {\n  @include link($color, $hover-color) {\n    &:hover {\n      &::after {\n        border-bottom-color: $hover-color;\n      }\n    }\n\n    &::after {\n      position: absolute;\n      bottom: 0;\n      content: \"\";\n      left: 0;\n      border-bottom: 1px solid $color;\n      width: 100%;\n    }\n  }\n}\n\n// flex 布局\n@mixin flex($obj) {\n  display: flex;\n\n  @if map-get($obj, \"justify\") {\n    justify-content: map-get($obj, \"justify\");\n  }\n\n  @if map-get($obj, \"align\") {\n    align-items: map-get($obj, \"align\");\n  }\n}\n\n// flex 水平居中\n@mixin flex-c {\n  @include flex((justify: center));\n}\n\n// flex 垂直居中\n@mixin flex-vc {\n  @include flex((align: center));\n}\n\n// flex 水平两端对齐\n@mixin flex-sb {\n  @include flex((justify: space-between));\n}\n\n// flex 水平垂直居中\n@mixin flex-cc {\n  @include flex((justify: center, align: center));\n}\n\n// flex 水平两端对齐，垂直居中\n@mixin flex-sbc {\n  @include flex((justify: space-between, align: center));\n}","@import \"@/styles/var.scss\";\n@import \"@/styles/mixin.scss\";\n\n.skin5 {\n  height: 100%;\n  background-color: #f5f6f9;\n\n  .header {\n    padding: 20px 16px 10px;\n    width: 100%;\n    background-repeat: no-repeat;\n    background-size: 100% 200px;\n    background-image: url(\"~@imgs/register/new-theme/head-bg.png\");\n\n    .logoBox {\n      font-size: 20px;\n      line-height: 20px;\n      display: flex;\n      align-items: center;\n\n      // @include flex-cc;\n\n      .logo {\n        margin-right: 10px;\n        width: 42px;\n        height: 42px;\n        background-size: 100%;\n        background-image: url(\"~@imgs/register/red-theme/logo-big.png\");\n      }\n\n      .logoBoxRight {\n        display: flex;\n        flex-direction: column;\n        font-size: 19px;\n        color: #fff;\n      }\n    }\n\n    .inputWrapper {\n      margin-top: 15px;\n      width: 343px;\n      background: linear-gradient(180deg, #FBE5D7 0%, #FFFFFF 27.54%);\n      border-radius: 8px;\n      padding-bottom: 25px;\n\n      .inputWrapperHead {\n        width: 100%;\n        height: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0 29px;\n        &.centerLayout {\n          justify-content: center;\n          .inputWrapperHeadItemImg {\n            width: 14px !important;\n            height: 14px !important;\n          }\n          .inputWrapperHeadItemText {\n            margin-top: 2px;\n          }\n        }\n        .inputWrapperHeadItem {\n          display: flex;\n          align-items: center;\n          .inputWrapperHeadItemImg {\n            width: 12px;\n            height: 14px;\n            margin-right: 6px;\n            display: block;\n          }\n          .inputWrapperHeadItemText {\n            font-size: 12px;\n            line-height: 12px;\n            color: #DE9960;\n          }\n        }\n      }\n\n      .inputWrapperContainer {\n        margin-top: 12px;\n        padding: 0 12px;\n        .inputWrapperContainetTips {\n          font-size: 14px;\n        }\n        .inputBox {\n          position: relative;\n          display: flex;\n          align-items: center;\n          // margin-top: -9px;\n          // border-bottom: 1px solid $border-color;\n          .inputBoxSymbol {\n            font-size: 38px;\n            line-height: 52px;\n          }\n    \n          :global {\n            .adm-input-element {\n              font-size: 30px;\n              // font-weight: 600;\n              line-height: 30px;\n              &::placeholder {\n                font-size: 22px;\n                line-height: 30px;\n              }\n            }\n          }\n    \n          .text {\n            position: absolute;\n            right: 0;\n            bottom: 14px;\n            display: flex;\n            align-items: center;\n            color: #AD6800;\n    \n            .clear {\n              padding-left: 9px;\n              color: #8C8C8C;\n              font-size: 16px;\n            }\n          }\n        }\n        .moneyOptions {\n          margin-top: 5px;\n          display: flex;\n          align-items: center;\n          .moneyItem {\n            width: 86px;\n            height: 30px;\n            padding: 4px 8px;\n            border-radius: 6px;\n            border: 1px solid #ff2f2f;\n            margin-right: 11px;\n            color: #ff2f2f;\n            box-sizing: border-box;\n            text-align: center;\n            font-size: 15px;\n          }\n        }\n      }\n    }\n  }\n\n  .checkBox {\n    width: 352px;\n    // height: 455px;\n    margin: 11px auto ;\n    background: #fff;\n    border-radius: 8px;\n    padding-bottom: 20px;\n    .title {\n      width: 100%;\n      height: 38px;\n      background: linear-gradient(180deg, #FDF2E5 0%, #FBE4CE 100%);\n      border-radius: 6px 6px 0px 0px;\n      text-align: center;\n      line-height: 38px;\n      font-weight: 400;\n      font-size: 12px;\n      color: #DE9960;\n    }\n    h3 {\n      font-weight: 600;\n      font-size: 16px;\n      color: #333;\n      padding: 16px 16px 6px;\n      span {\n        font-size: 12px;\n        color: #BB6C1D;\n        font-weight: normal;\n      }\n    }\n    .loanTermList {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      padding: 0 16px;\n      .loanTermItem {\n        margin-top: 8px;\n        width: 154px;\n        height: 60px;\n        padding-bottom: 6px;\n        background-color: #f3f4f6;\n        text-align: center;\n        border-radius: 4px;\n        font-size: 15px;\n        box-sizing: border-box;\n        p {\n          margin-top: 6px;\n          color: #8C8C8C;\n          &.samllText {\n            font-size: 12px;\n          }\n        }\n        &.active {\n          background-color: #fff9f4;\n          border: 1Px solid #bb9674;\n          p {\n            color: #bb9674;\n          }\n        }\n        &.is360Channel {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 16px;\n        }\n      }\n    }\n\n    .bottomBody {\n      margin-top: 20px;\n      box-sizing: border-box;\n      padding: 0 16px;\n      p {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        span {\n          display: inline-block;\n          color: #c16818;\n          height: 41px;\n          line-height: 41px;\n          padding: 0 16px;\n          background-repeat: no-repeat;\n          background-size: 100% 100%;\n          background-image: url(\"~@imgs/register/new-theme/bottom-body-bg.png\");\n        }\n      }\n      .phoneBox {\n        height: 50px;\n        background: #f4f5f7;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        margin: 9px auto 0;\n        .label {\n          width: 170px;\n          text-align: center;\n          font-size: 16px;\n        }\n        :global {\n          .adm-input-element {\n            font-size: 16px;\n            // font-weight: 600;\n            line-height: 30px;\n            &::placeholder {\n              font-size: 16px;\n              line-height: 30px;\n            }\n          }\n        }\n      }\n      .getCms {\n        margin-top: 12px;\n        height: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-image: linear-gradient(180deg,#ffcfa0 1%,#e19459);\n        border-radius: 6px;\n        color: #FFFFFF;\n        font-size: 16px;\n      }\n      .agreement {\n        @include flex-cc;\n        flex-wrap: wrap;\n        \n        .primary {\n          color: #DE9960;\n        }\n    \n        margin-top: 12px;\n        font-size: 12px;\n        color: #8C8C8C;\n        line-height: 18px;\n\n        &.animation {\n          position: relative;\n          animation: shake .1s;\n        }\n\n        @keyframes shake {\n          0% {\n            left: 8px;\n          }\n\n          50% {\n            left: -8px;\n          }\n    \n          100% {\n            left: 0;\n          }\n        }\n    \n        .checked {\n          margin-right: 6px;\n          border: 1px solid #D9D9D9;\n          border-radius: 100%;\n          width: 18px;\n          height: 18px;\n          // background-color: #DE9960;\n    \n          &.active {\n            position: relative;\n            border: none;\n            background: #DE9960;\n    \n            &::before {\n              position: absolute;\n              top: 6px;\n              left: 4px;\n              width: 10px;\n              height: 7px;\n              content: \"\";\n              background-image: url(\"~@imgs/activity/check.png\");\n              background-size: 100%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .tipBox {\n    padding-bottom: 50px;\n    .tip {\n      font-size: 12px;\n      line-height: 20px;\n      text-align: center;\n      color: $text-gray-color;\n    }\n  }\n\n  .dialogOverlay {\n    width: 100%;\n    height: 100vh;\n    background-color: rgba(0,0,0,.7);\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    display: none;\n    &.showPopup {\n      display: block;\n    }\n    .dialogMain {\n      width: 320px;\n      height: 180px;\n      border-radius: 8px;\n      background-color: #fff;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      padding: 20px 0;\n      box-sizing: border-box;\n      .close {\n        width: 100%;\n        font-size: 20px;\n        text-align: right;\n        margin-right: 20px;\n        color: rgb(214, 217, 223);\n        padding-right: 20px;\n        box-sizing: border-box;\n      }\n      .inputBox {\n        width: 285px;\n        height: 48px;\n        border: 1px solid #e19459;\n        margin: 10px auto;\n        padding-left: 20px;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        .code {\n          width: 150px;\n          text-align: center;\n          color: #e19459;\n        }\n        :global {\n          .adm-input-element {\n            font-size: 15px;\n            // font-weight: 600;\n            line-height: 30px;\n          }\n        }\n      }\n      .limit {\n        margin: 18px auto;\n        width: 283px;\n        height: 44px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-image: linear-gradient(180deg,#ffcfa0 1%,#e19459);\n        border-radius: 6px;\n        color: #FFFFFF;\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n:global {\n  .adm-auto-center {\n    .adm-auto-center-content {\n      text-align: center !important;\n    }\n  }\n}\n","// 公共颜色\n$color-primary: #FF4D4F;\n\n// 主字色\n$color-black: #262626;\n$color-white: #FFFFFF;\n\n// 浅红\n$light-red: #FFF1F0;\n\n// 浅红背景\n$light-red-bg: #FFF3F4;\n\n// 背景色\n$background-color: #F6F6F6;\n\n// 线条颜色\n$line-color: #F0F0F0;\n\n// 边框颜色\n$border-color: #D9D9D9;\n\n// 文字灰色颜色\n$text-gray-color: #8C8C8C;\n\n// 渐变色\n$linear-gradient: linear-gradient(108.61deg, #FF606E 3.46%, #FF192C 97.1%);\n\n// skin12字体颜色\n$text-skin12: #684aff;\n\n// skin12渐变色\n$linear-gradient-skin12: linear-gradient(1turn, #a18eff, #684aff);\n\n// 占位符颜色\n$placeholder-color: #BFBFBF;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skin5": `skin7_skin5__wQ8jZ`,
	"header": `skin7_header__BM6am`,
	"logoBox": `skin7_logoBox__bLuyg`,
	"logo": `skin7_logo__NcaXX`,
	"logoBoxRight": `skin7_logoBoxRight__+XO6p`,
	"inputWrapper": `skin7_inputWrapper__UmLmw`,
	"inputWrapperHead": `skin7_inputWrapperHead__4siQy`,
	"centerLayout": `skin7_centerLayout__WDexa`,
	"inputWrapperHeadItemImg": `skin7_inputWrapperHeadItemImg__i7cxf`,
	"inputWrapperHeadItemText": `skin7_inputWrapperHeadItemText__+Ah-W`,
	"inputWrapperHeadItem": `skin7_inputWrapperHeadItem__IquW8`,
	"inputWrapperContainer": `skin7_inputWrapperContainer__TPzLe`,
	"inputWrapperContainetTips": `skin7_inputWrapperContainetTips__8jjsl`,
	"inputBox": `skin7_inputBox__pQ4ea`,
	"inputBoxSymbol": `skin7_inputBoxSymbol__cyJYQ`,
	"text": `skin7_text__B0+3s`,
	"clear": `skin7_clear__YtGpD`,
	"moneyOptions": `skin7_moneyOptions__FRkHP`,
	"moneyItem": `skin7_moneyItem__Lnvkr`,
	"checkBox": `skin7_checkBox__fn8-M`,
	"title": `skin7_title__A0yao`,
	"loanTermList": `skin7_loanTermList__WVgKL`,
	"loanTermItem": `skin7_loanTermItem__9OeE2`,
	"samllText": `skin7_samllText__oEW1+`,
	"active": `skin7_active__PKBkj`,
	"is360Channel": `skin7_is360Channel__vTrNI`,
	"bottomBody": `skin7_bottomBody__FEibS`,
	"phoneBox": `skin7_phoneBox__uxHPK`,
	"label": `skin7_label__pGNH6`,
	"getCms": `skin7_getCms__7A595`,
	"agreement": `skin7_agreement__mWN77`,
	"primary": `skin7_primary__Xej6e`,
	"animation": `skin7_animation__202Uy`,
	"shake": `skin7_shake__IZRek`,
	"checked": `skin7_checked__TE4gh`,
	"tipBox": `skin7_tipBox__Pz5yg`,
	"tip": `skin7_tip__2tMiY`,
	"dialogOverlay": `skin7_dialogOverlay__EAcoE`,
	"showPopup": `skin7_showPopup__5UUvZ`,
	"dialogMain": `skin7_dialogMain__mPBLq`,
	"close": `skin7_close__r2dDW`,
	"code": `skin7_code__6Lh5J`,
	"limit": `skin7_limit__JqhXn`,
	"rotate": `skin7_rotate__eJRAR`
};
export default ___CSS_LOADER_EXPORT___;
